// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   PublicInput — Comment by agenda item (public comments view)
   Scoped under .public-comment-root. Tokens are defined locally so the
   bundle is self-contained regardless of the host page's CSS variables.
   ============================================================ */
.public-comment-root {
  /* brand tokens (subset of the design system, prefixed to avoid host clashes) */
  --pc-blue: #0395ff;
  --pc-blue-deep: #0383e0;
  --pc-blue-pale: #dbf1ff;
  --pc-ink: #333333;
  --pc-muted: #696868;
  --pc-subtle: #8997a1; /* decorative / placeholders / icon strokes only */
  --pc-text-subtle: #5b6873; /* AA-compliant subtle TEXT (>=4.5:1 on white) */
  --pc-border: #c4cdd4;
  --pc-border-soft: #eaedef;
  --pc-gray-100: #f5f8fa;
  --pc-gray-200: #eaedef;
  --pc-gray-300: #c4cdd4;
  --pc-orange: #ff7c1d;
  --pc-orange-soft: #f6a572;
  --pc-orange-pale: #ffdec7;
  --pc-teal-deep: #07afaa;
  --pc-bg-tinted: #f8fafb;
  --pc-radius-md: 6px;
  --pc-radius-lg: 8px;
  --pc-radius-pill: 9999px;
  --pc-fast: 120ms ease-out;
  --pc-base: 180ms ease-out;

  color: var(--pc-ink);
  line-height: 1.5;
  padding: 0;
}

/* ---------- Card shell (personal info + agenda) ---------- */
.public-comment-root .pc-card {
  background: #fff;
  border: none;
  border-bottom: 1px solid var(--pc-border-soft);
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
}
.public-comment-root .pc-card:last-child {
  border-bottom: none;
}
.public-comment-root .pc-card-header {
  padding: 16px 24px;
  border-bottom: 1px solid var(--pc-border-soft);
}
.public-comment-root .pc-card-body {
  padding: 24px;
}
.public-comment-root .pc-card-title {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
}
.public-comment-root .pc-card-subtitle {
  font-size: 13px;
  color: var(--pc-muted);
  margin: 3px 0 0;
}
.public-comment-root .pc-agenda-card {
  padding: 24px;
}

/* ---------- Notice ---------- */
.public-comment-root .pc-notice {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
}
.public-comment-root .pc-notice-content {
  flex: 1;
  min-width: 0;
}
.public-comment-root .pc-notice-text {
  font-size: 13px;
  color: var(--pc-muted);
  line-height: 1.6;
}
.public-comment-root .pc-notice-text strong {
  color: var(--pc-ink);
}
.public-comment-root .pc-link-btn {
  background: none;
  border: none;
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-blue);
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
}
.public-comment-root .pc-link-btn:hover {
  text-decoration: underline;
}
.public-comment-root .pc-ml-xs {
  margin-left: 4px;
}

/* ---------- Form fields (personal information) ---------- */
.public-comment-root .pc-field-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}
.public-comment-root .pc-field {
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.public-comment-root .pc-label {
  display: block;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  color: var(--pc-ink);
}
.public-comment-root .pc-required {
  color: var(--pc-blue);
  margin-left: 2px;
}
.public-comment-root .pc-input {
  width: 100%;
  border: 1px solid var(--pc-border);
  border-radius: var(--pc-radius-md);
  padding: 11px 13px;
  font-size: 15px;
  color: var(--pc-ink);
  background: #fff;
  transition: border-color var(--pc-fast), box-shadow var(--pc-fast);
  box-sizing: border-box;
}
.public-comment-root .pc-input:focus {
  outline: none;
  border-color: var(--pc-blue);
  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);
}
.public-comment-root .pc-input::-moz-placeholder {
  color: var(--pc-subtle);
}
.public-comment-root .pc-input::placeholder {
  color: var(--pc-subtle);
}
.public-comment-root .pc-input-error {
  border-color: #c0392b;
  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.14);
}
.public-comment-root .pc-error-text {
  display: block;
  font-size: 12.5px;
  color: #c0392b;
  margin-top: 2px;
}

/* ---------- Agenda header + search ---------- */
.public-comment-root .pc-ag-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.public-comment-root .pc-ag-top-left {
  min-width: 0;
}
.public-comment-root .pc-search {
  position: relative;
  flex: 0 0 320px;
  max-width: 320px;
}
.public-comment-root .pc-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 17px;
  stroke: var(--pc-subtle);
  fill: none;
  stroke-width: 2;
  pointer-events: none;
}
.public-comment-root .pc-search-input {
  padding-left: 38px;
}

/* ---------- Agenda list ---------- */
.public-comment-root .pc-ag-colhead {
  display: grid;
  grid-template-columns: 96px 1fr auto;
  align-items: center;
  gap: 16px;
  padding: 10px 16px;
  background: var(--pc-gray-100);
  border: 1px solid var(--pc-border-soft);
  border-bottom: 0;
  border-radius: var(--pc-radius-lg) var(--pc-radius-lg) 0 0;
}
.public-comment-root .pc-ag-colhead span {
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pc-muted);
}
.public-comment-root .pc-ag-list {
  border: 1px solid var(--pc-border-soft);
  border-radius: 0 0 var(--pc-radius-lg) var(--pc-radius-lg);
  overflow: hidden;
}
.public-comment-root .pc-ag-row {
  border-top: 1px solid var(--pc-border-soft);
}
.public-comment-root .pc-ag-list > .pc-ag-row:first-child {
  border-top: 0;
}
.public-comment-root .pc-ag-rowhead {
  display: grid;
  grid-template-columns: 96px 1fr auto auto;
  align-items: center;
  gap: 16px;
  padding: 16px;
  cursor: pointer;
  transition: background var(--pc-fast);
}
.public-comment-root .pc-ag-rowhead:hover {
  background: var(--pc-gray-100);
}
.public-comment-root .pc-ag-rowhead:focus-visible {
  outline: 2px solid var(--pc-blue);
  outline-offset: -2px;
}
.public-comment-root .pc-ag-row.pc-open > .pc-ag-rowhead {
  background: var(--pc-blue-pale);
}
.public-comment-root .pc-ag-code {
  font-weight: 600;
  font-size: 14px;
  color: var(--pc-blue);
  background: rgba(3, 149, 255, 0.1);
  border-radius: var(--pc-radius-md);
  padding: 5px 0;
  text-align: center;
  min-width: 52px;
}
.public-comment-root .pc-ag-title {
  font-size: 15.5px;
  line-height: 1.45;
  color: var(--pc-ink);
  min-width: 0;
}

/* comment-count pill */
.public-comment-root .pc-ag-count {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
  font-size: 13.5px;
  padding: 6px 12px;
  border-radius: var(--pc-radius-pill);
  white-space: nowrap;
  transition: background var(--pc-fast);
}
.public-comment-root .pc-ag-count svg {
  width: 15px;
  height: 15px;
  fill: currentColor;
  stroke: none;
}
.public-comment-root .pc-ag-count.pc-has {
  background: rgba(3, 149, 255, 0.12);
  color: var(--pc-blue);
}
.public-comment-root .pc-ag-rowhead:hover .pc-ag-count.pc-has {
  background: rgba(3, 149, 255, 0.2);
}
.public-comment-root .pc-ag-count.pc-none {
  background: transparent;
  color: var(--pc-text-subtle);
  font-weight: 400;
}
.public-comment-root .pc-ag-chev {
  width: 20px;
  height: 20px;
  stroke: var(--pc-subtle);
  fill: none;
  stroke-width: 2;
  transition: transform var(--pc-base);
  justify-self: end;
}
.public-comment-root .pc-ag-row.pc-open .pc-ag-chev {
  transform: rotate(180deg);
  stroke: var(--pc-blue);
}

/* ---------- Expanded panel ---------- */
.public-comment-root .pc-ag-panel {
  padding: 4px 16px 22px;
  background: var(--pc-bg-tinted);
  border-top: 1px solid var(--pc-border-soft);
}
.public-comment-root .pc-panel-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 2px 12px;
  flex-wrap: wrap;
}
.public-comment-root .pc-panel-lbl {
  font-weight: 700;
  font-size: 14px;
  color: var(--pc-ink);
}
.public-comment-root .pc-sortseg {
  display: inline-flex;
  background: #fff;
  border: 1px solid var(--pc-border);
  border-radius: var(--pc-radius-pill);
  padding: 2px;
}
.public-comment-root .pc-sortseg button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--pc-muted);
  padding: 5px 13px;
  border-radius: var(--pc-radius-pill);
  transition: all var(--pc-fast);
}
.public-comment-root .pc-sortseg button.pc-on {
  background: var(--pc-blue);
  color: #fff;
}

/* ---------- Comment thread ---------- */
.public-comment-root .pc-thread {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.public-comment-root .pc-cmt {
  padding: 14px 2px;
  border-top: 1px solid var(--pc-border-soft);
  display: grid;
  grid-template-columns: 38px 1fr;
  gap: 13px;
}
.public-comment-root .pc-thread > .pc-cmt:first-child {
  border-top: 0;
}
.public-comment-root .pc-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13.5px;
  color: #fff;
  flex: 0 0 38px;
}
.public-comment-root .pc-avatar-sm {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  font-size: 11px;
}
.public-comment-root .pc-avatar-anon {
  background: var(--pc-gray-300);
  color: #fff;
}
.public-comment-root .pc-avatar-anon svg {
  width: 19px;
  height: 19px;
  fill: #fff;
  stroke: none;
}
.public-comment-root .pc-avatar-sm.pc-avatar-anon svg {
  width: 15px;
  height: 15px;
}
.public-comment-root .pc-cmt-main {
  min-width: 0;
}
.public-comment-root .pc-cmt-head {
  display: flex;
  align-items: center;
  gap: 9px;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
.public-comment-root .pc-cmt-name {
  font-weight: 600;
  font-size: 14.5px;
  color: var(--pc-ink);
}
.public-comment-root .pc-cmt-time {
  font-size: 12.5px;
  color: var(--pc-text-subtle);
}
.public-comment-root .pc-pos-chip {
  font-weight: 600;
  font-size: 11px;
  padding: 2px 9px;
  border-radius: var(--pc-radius-pill);
}
.public-comment-root .pc-pos-favor {
  background: rgba(7, 175, 170, 0.12);
  color: var(--pc-teal-deep);
}
.public-comment-root .pc-pos-oppose {
  background: var(--pc-orange-pale);
  color: #c25a08;
}
.public-comment-root .pc-cmt-body {
  font-size: 14.5px;
  line-height: 1.6;
  color: var(--pc-ink);
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.public-comment-root .pc-cmt-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 9px;
}
.public-comment-root .pc-cact {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  background: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-muted);
  padding: 5px 10px;
  border-radius: var(--pc-radius-md);
  transition: all var(--pc-fast);
}
.public-comment-root .pc-cact svg {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
}
.public-comment-root .pc-cact:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.05);
  color: var(--pc-ink);
}
.public-comment-root .pc-cact:disabled {
  cursor: default;
}
.public-comment-root .pc-cact-vote.pc-on {
  color: var(--pc-blue);
}
.public-comment-root .pc-cact-vote.pc-on svg {
  fill: var(--pc-blue);
  stroke: var(--pc-blue);
}
.public-comment-root .pc-ct {
  font-variant-numeric: tabular-nums;
}
.public-comment-root .pc-sep {
  margin-left: auto;
}

/* replies */
.public-comment-root .pc-replies {
  margin-top: 12px;
  padding-left: 18px;
  border-left: 2px solid var(--pc-border-soft);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.public-comment-root .pc-reply {
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 11px;
}
.public-comment-root .pc-staff-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-weight: 700;
  font-size: 11px;
  color: var(--pc-blue);
  background: var(--pc-blue-pale);
  padding: 2px 9px;
  border-radius: var(--pc-radius-pill);
}
.public-comment-root .pc-staff-badge svg {
  width: 12px;
  height: 12px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.4;
}

/* pending (author-only) */
.public-comment-root .pc-cmt-pending .pc-cmt-body {
  font-style: italic;
  color: var(--pc-muted);
}
.public-comment-root .pc-pending-note {
  display: flex;
  gap: 9px;
  margin-top: 9px;
  font-size: 12.5px;
  color: var(--pc-muted);
  background: var(--pc-gray-200);
  padding: 8px 12px;
  border-radius: var(--pc-radius-md);
  align-items: flex-start;
}
.public-comment-root .pc-pending-note svg {
  width: 15px;
  height: 15px;
  stroke: var(--pc-muted);
  fill: none;
  stroke-width: 2;
  flex: 0 0 15px;
  margin-top: 1px;
}

/* inline reply box */
.public-comment-root .pc-replybox {
  margin-top: 12px;
  padding-left: 18px;
}
.public-comment-root .pc-replybox textarea {
  width: 100%;
  min-height: 62px;
  resize: vertical;
  font: inherit;
  font-size: 14px;
  padding: 10px 12px;
  border: 1px solid var(--pc-border);
  border-radius: var(--pc-radius-md);
  background: #fff;
  box-sizing: border-box;
}
.public-comment-root .pc-replybox textarea:focus {
  outline: none;
  border-color: var(--pc-blue);
  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);
}
.public-comment-root .pc-rb-foot {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.public-comment-root .pc-empty {
  padding: 18px 2px;
  font-size: 14px;
  color: var(--pc-text-subtle);
  font-style: italic;
}
.public-comment-root .pc-empty-pad {
  padding: 18px 16px;
}

/* ---------- Compose ---------- */
.public-comment-root .pc-compose {
  margin-top: 16px;
  padding: 16px;
  background: #fff;
  border: 1px solid var(--pc-border-soft);
  border-radius: var(--pc-radius-lg);
}
.public-comment-root .pc-compose-h {
  font-weight: 700;
  font-size: 13.5px;
  color: var(--pc-ink);
  margin: 0 0 10px;
}
.public-comment-root .pc-compose-input {
  width: 100%;
  min-height: 78px;
  resize: vertical;
  font: inherit;
  font-size: 14.5px;
  padding: 11px 13px;
  border: 1px solid var(--pc-border);
  border-radius: var(--pc-radius-md);
  background: #fff;
  box-sizing: border-box;
}
.public-comment-root .pc-compose-input:focus {
  outline: none;
  border-color: var(--pc-blue);
  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);
}
.public-comment-root .pc-compose-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-top: 11px;
  flex-wrap: wrap;
}
.public-comment-root .pc-compose-as {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--pc-muted);
}
.public-comment-root .pc-av-mini {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 10px;
  color: #fff;
  background: var(--pc-blue);
}
.public-comment-root .pc-av-mini-anon {
  background: var(--pc-gray-300);
}
.public-comment-root .pc-av-mini-anon svg {
  width: 13px;
  height: 13px;
  fill: #fff;
  stroke: none;
}
.public-comment-root .pc-av-mini-staff {
  background: var(--pc-blue);
}

/* "Post on behalf of {agency}" — shown to meeting admins only */
.public-comment-root .pc-post-as {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 11px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-blue);
  cursor: pointer;
}
.public-comment-root .pc-post-as input {
  width: 15px;
  height: 15px;
  accent-color: var(--pc-blue);
  cursor: pointer;
}
.public-comment-root .pc-post-as svg {
  width: 13px;
  height: 13px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.4;
}
.public-comment-root .pc-compose-as strong {
  color: var(--pc-ink);
  font-weight: 600;
}

/* stance picker */
.public-comment-root .pc-stance-pick {
  display: inline-flex;
  gap: 7px;
  margin-right: auto;
}
.public-comment-root .pc-stance-pick label {
  cursor: pointer;
  position: relative;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--pc-muted);
  border: 1px solid var(--pc-border);
  border-radius: var(--pc-radius-pill);
  padding: 5px 13px;
  background: #fff;
  transition: all var(--pc-fast);
}
.public-comment-root .pc-stance-pick label input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
/* The radio is visually hidden, so surface keyboard focus on its label (WCAG 2.4.7). */
.public-comment-root .pc-stance-pick label:focus-within {
  outline: 2px solid var(--pc-blue);
  outline-offset: 1px;
}
.public-comment-root .pc-stance-pick .pc-favor.pc-checked {
  border-color: var(--pc-teal-deep);
  background: rgba(7, 175, 170, 0.1);
  color: var(--pc-teal-deep);
}
.public-comment-root .pc-stance-pick .pc-oppose.pc-checked {
  border-color: var(--pc-orange);
  background: var(--pc-orange-pale);
  color: #c25a08;
}
.public-comment-root .pc-stance-pick .pc-neutral.pc-checked {
  border-color: var(--pc-muted);
  background: var(--pc-gray-200);
  color: var(--pc-ink);
}

/* ---------- Buttons ---------- */
.public-comment-root .pc-btn {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: 0;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: var(--pc-radius-lg);
  transition: background var(--pc-base), transform var(--pc-fast);
}
.public-comment-root .pc-btn-primary {
  background: var(--pc-blue);
  color: #fff;
}
.public-comment-root .pc-btn-primary:hover:not(:disabled) {
  background: var(--pc-blue-deep);
}
.public-comment-root .pc-btn-primary:active {
  transform: translateY(1px);
}
.public-comment-root .pc-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
.public-comment-root .pc-btn-ghost {
  background: transparent;
  color: var(--pc-muted);
  font-size: 13px;
  padding: 8px 14px;
}
.public-comment-root .pc-btn-ghost:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--pc-ink);
}
.public-comment-root .pc-btn-sm {
  font-size: 13px;
  padding: 8px 16px;
}
/* Inline processing spinner shown in Submit / Reply buttons while a post is in flight. */
.public-comment-root .pc-spin {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin-right: 7px;
  vertical-align: -2px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: pc-spin 0.6s linear infinite;
}
@keyframes pc-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .public-comment-root .pc-spin {
    animation-duration: 1.4s;
  }
}

/* ---------- Moderation notice ---------- */
.public-comment-root .pc-mod-notice {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  padding: 13px 15px;
  background: var(--pc-orange-pale);
  border: 1px solid var(--pc-orange-soft);
  border-radius: var(--pc-radius-lg);
  animation: pc-fade 200ms ease-out;
}
.public-comment-root .pc-mod-notice svg {
  width: 20px;
  height: 20px;
  stroke: #c25a08;
  fill: none;
  stroke-width: 2;
  flex: 0 0 20px;
  margin-top: 1px;
}
.public-comment-root .pc-mn-t {
  font-weight: 700;
  font-size: 14px;
  color: #a04a06;
  margin: 0 0 3px;
}
.public-comment-root .pc-mn-d {
  font-size: 13.5px;
  line-height: 1.55;
  color: #8a4408;
  margin: 0;
}
@keyframes pc-fade {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* ---------- Responsive ---------- */
@media (max-width: 720px) {
  .public-comment-root .pc-field-grid {
    grid-template-columns: 1fr;
  }
  .public-comment-root .pc-ag-colhead {
    grid-template-columns: 60px 1fr auto;
  }
  /* Keep the chevron disclosure affordance on touch/kiosk widths (its own column). */
  .public-comment-root .pc-ag-rowhead {
    grid-template-columns: 60px 1fr auto auto;
  }
  .public-comment-root .pc-search {
    flex-basis: 100%;
    max-width: none;
  }
  .public-comment-root .pc-compose-foot {
    align-items: stretch;
  }
}

/* ---------- Attachments (composer) ---------- */
.public-comment-root .pc-attach {
  margin-top: 11px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.public-comment-root .pc-attach-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
}
.public-comment-root .pc-attach-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  padding: 5px 8px;
  background: var(--pc-gray-100);
  border: 1px solid var(--pc-border-soft);
  border-radius: var(--pc-radius-md);
  font-size: 12.5px;
  color: var(--pc-ink);
}
.public-comment-root .pc-attach-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
.public-comment-root .pc-attach-size {
  color: var(--pc-text-subtle);
  font-size: 11.5px;
}
.public-comment-root .pc-attach-ic {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
  flex-shrink: 0;
}
.public-comment-root .pc-attach-rm {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  margin-left: 2px;
  cursor: pointer;
  color: var(--pc-muted);
}
.public-comment-root .pc-attach-rm svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.2;
}
.public-comment-root .pc-attach-rm:hover {
  color: var(--pc-ink);
}
.public-comment-root .pc-attach-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 11px;
  border: 1px dashed var(--pc-border);
  border-radius: var(--pc-radius-md);
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-blue);
  cursor: pointer;
  transition: background var(--pc-fast), border-color var(--pc-fast);
}
.public-comment-root .pc-attach-add:hover {
  background: var(--pc-blue-pale);
  border-color: var(--pc-blue);
}
.public-comment-root .pc-attach-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
.public-comment-root .pc-attach-hint {
  font-size: 11.5px;
  color: var(--pc-text-subtle);
}
.public-comment-root .pc-attach-err {
  width: 100%;
  margin: 2px 0 0;
  font-size: 12.5px;
  color: #c0392b;
}

/* ---------- Private (hidden) comment toggle ---------- */
.public-comment-root .pc-private {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 11px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-text-subtle);
  cursor: pointer;
}
.public-comment-root .pc-private input {
  width: 15px;
  height: 15px;
  accent-color: var(--pc-blue);
  cursor: pointer;
}
.public-comment-root .pc-private svg {
  width: 13px;
  height: 13px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.2;
}
.public-comment-root .pc-av-mini-private {
  background: var(--pc-text-subtle);
}
.public-comment-root .pc-av-mini-private svg {
  width: 12px;
  height: 12px;
  stroke: #fff;
  fill: none;
  stroke-width: 2.2;
}
.public-comment-root .pc-private-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 7px;
  border-radius: var(--pc-radius-pill);
  background: var(--pc-gray-200);
  color: var(--pc-text-subtle);
  font-size: 11.5px;
  font-weight: 600;
}
.public-comment-root .pc-private-badge svg {
  width: 11px;
  height: 11px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2.2;
}

/* ---------- Reply admin toggle ---------- */
.public-comment-root .pc-post-as-reply {
  margin-top: 8px;
  margin-bottom: 2px;
}

/* ---------- Comment attachments (feed) ---------- */
.public-comment-root .pc-cmt-atts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 2px;
}
.public-comment-root .pc-att-img {
  display: block;
  border-radius: var(--pc-radius-md);
  overflow: hidden;
  border: 1px solid var(--pc-border-soft);
  max-width: 180px;
}
.public-comment-root .pc-att-img img {
  display: block;
  max-width: 180px;
  max-height: 160px;
  -o-object-fit: cover;
     object-fit: cover;
}
.public-comment-root .pc-att-doc {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 11px;
  background: var(--pc-gray-100);
  border: 1px solid var(--pc-border-soft);
  border-radius: var(--pc-radius-md);
  font-size: 13px;
  font-weight: 600;
  color: var(--pc-blue);
  text-decoration: none;
}
.public-comment-root .pc-att-doc:hover {
  background: var(--pc-blue-pale);
}
.public-comment-root .pc-att-doc-ic {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  fill: none;
  stroke-width: 2;
}
.public-comment-root .pc-att-doc-name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./Scripts/Modules/PublicComment/styles/public-comment.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;AACjE;EACE,+EAA+E;EAC/E,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB,EAAE,kDAAkD;EACxE,yBAAyB,EAAE,gDAAgD;EAC3E,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;;EAEzB,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,kEAAkE;EAClE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;AACA;EACE,uBAAuB;AACzB;AAFA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,0DAA0D;EAC1D,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kCAAkC;EAClC,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA,uFAAuF;AACvF;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,+DAA+D;AACjE;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA,yFAAyF;AACzF;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,oCAAoC;EACtC;EACA,mFAAmF;EACnF;IACE,yCAAyC;EAC3C;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,iDAAiD;AACjD;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,uCAAuC;EACvC,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,kEAAkE;AACpE;AACA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAiB;KAAjB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;EAC9B,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["/* ============================================================\r\n   PublicInput — Comment by agenda item (public comments view)\r\n   Scoped under .public-comment-root. Tokens are defined locally so the\r\n   bundle is self-contained regardless of the host page's CSS variables.\r\n   ============================================================ */\r\n.public-comment-root {\r\n  /* brand tokens (subset of the design system, prefixed to avoid host clashes) */\r\n  --pc-blue: #0395ff;\r\n  --pc-blue-deep: #0383e0;\r\n  --pc-blue-pale: #dbf1ff;\r\n  --pc-ink: #333333;\r\n  --pc-muted: #696868;\r\n  --pc-subtle: #8997a1; /* decorative / placeholders / icon strokes only */\r\n  --pc-text-subtle: #5b6873; /* AA-compliant subtle TEXT (>=4.5:1 on white) */\r\n  --pc-border: #c4cdd4;\r\n  --pc-border-soft: #eaedef;\r\n  --pc-gray-100: #f5f8fa;\r\n  --pc-gray-200: #eaedef;\r\n  --pc-gray-300: #c4cdd4;\r\n  --pc-orange: #ff7c1d;\r\n  --pc-orange-soft: #f6a572;\r\n  --pc-orange-pale: #ffdec7;\r\n  --pc-teal-deep: #07afaa;\r\n  --pc-bg-tinted: #f8fafb;\r\n  --pc-radius-md: 6px;\r\n  --pc-radius-lg: 8px;\r\n  --pc-radius-pill: 9999px;\r\n  --pc-fast: 120ms ease-out;\r\n  --pc-base: 180ms ease-out;\r\n\r\n  color: var(--pc-ink);\r\n  line-height: 1.5;\r\n  padding: 0;\r\n}\r\n\r\n/* ---------- Card shell (personal info + agenda) ---------- */\r\n.public-comment-root .pc-card {\r\n  background: #fff;\r\n  border: none;\r\n  border-bottom: 1px solid var(--pc-border-soft);\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  margin-bottom: 0;\r\n}\r\n.public-comment-root .pc-card:last-child {\r\n  border-bottom: none;\r\n}\r\n.public-comment-root .pc-card-header {\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid var(--pc-border-soft);\r\n}\r\n.public-comment-root .pc-card-body {\r\n  padding: 24px;\r\n}\r\n.public-comment-root .pc-card-title {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n.public-comment-root .pc-card-subtitle {\r\n  font-size: 13px;\r\n  color: var(--pc-muted);\r\n  margin: 3px 0 0;\r\n}\r\n.public-comment-root .pc-agenda-card {\r\n  padding: 24px;\r\n}\r\n\r\n/* ---------- Notice ---------- */\r\n.public-comment-root .pc-notice {\r\n  display: flex;\r\n  gap: 12px;\r\n  padding: 20px 24px;\r\n}\r\n.public-comment-root .pc-notice-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n.public-comment-root .pc-notice-text {\r\n  font-size: 13px;\r\n  color: var(--pc-muted);\r\n  line-height: 1.6;\r\n}\r\n.public-comment-root .pc-notice-text strong {\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-link-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-blue);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n.public-comment-root .pc-link-btn:hover {\r\n  text-decoration: underline;\r\n}\r\n.public-comment-root .pc-ml-xs {\r\n  margin-left: 4px;\r\n}\r\n\r\n/* ---------- Form fields (personal information) ---------- */\r\n.public-comment-root .pc-field-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  gap: 16px;\r\n}\r\n.public-comment-root .pc-field {\r\n  margin-bottom: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n}\r\n.public-comment-root .pc-label {\r\n  display: block;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  margin: 0;\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-required {\r\n  color: var(--pc-blue);\r\n  margin-left: 2px;\r\n}\r\n.public-comment-root .pc-input {\r\n  width: 100%;\r\n  border: 1px solid var(--pc-border);\r\n  border-radius: var(--pc-radius-md);\r\n  padding: 11px 13px;\r\n  font-size: 15px;\r\n  color: var(--pc-ink);\r\n  background: #fff;\r\n  transition: border-color var(--pc-fast), box-shadow var(--pc-fast);\r\n  box-sizing: border-box;\r\n}\r\n.public-comment-root .pc-input:focus {\r\n  outline: none;\r\n  border-color: var(--pc-blue);\r\n  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);\r\n}\r\n.public-comment-root .pc-input::placeholder {\r\n  color: var(--pc-subtle);\r\n}\r\n.public-comment-root .pc-input-error {\r\n  border-color: #c0392b;\r\n  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.14);\r\n}\r\n.public-comment-root .pc-error-text {\r\n  display: block;\r\n  font-size: 12.5px;\r\n  color: #c0392b;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* ---------- Agenda header + search ---------- */\r\n.public-comment-root .pc-ag-top {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n.public-comment-root .pc-ag-top-left {\r\n  min-width: 0;\r\n}\r\n.public-comment-root .pc-search {\r\n  position: relative;\r\n  flex: 0 0 320px;\r\n  max-width: 320px;\r\n}\r\n.public-comment-root .pc-search-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 17px;\r\n  height: 17px;\r\n  stroke: var(--pc-subtle);\r\n  fill: none;\r\n  stroke-width: 2;\r\n  pointer-events: none;\r\n}\r\n.public-comment-root .pc-search-input {\r\n  padding-left: 38px;\r\n}\r\n\r\n/* ---------- Agenda list ---------- */\r\n.public-comment-root .pc-ag-colhead {\r\n  display: grid;\r\n  grid-template-columns: 96px 1fr auto;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 10px 16px;\r\n  background: var(--pc-gray-100);\r\n  border: 1px solid var(--pc-border-soft);\r\n  border-bottom: 0;\r\n  border-radius: var(--pc-radius-lg) var(--pc-radius-lg) 0 0;\r\n}\r\n.public-comment-root .pc-ag-colhead span {\r\n  font-weight: 700;\r\n  font-size: 11px;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  color: var(--pc-muted);\r\n}\r\n.public-comment-root .pc-ag-list {\r\n  border: 1px solid var(--pc-border-soft);\r\n  border-radius: 0 0 var(--pc-radius-lg) var(--pc-radius-lg);\r\n  overflow: hidden;\r\n}\r\n.public-comment-root .pc-ag-row {\r\n  border-top: 1px solid var(--pc-border-soft);\r\n}\r\n.public-comment-root .pc-ag-list > .pc-ag-row:first-child {\r\n  border-top: 0;\r\n}\r\n.public-comment-root .pc-ag-rowhead {\r\n  display: grid;\r\n  grid-template-columns: 96px 1fr auto auto;\r\n  align-items: center;\r\n  gap: 16px;\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  transition: background var(--pc-fast);\r\n}\r\n.public-comment-root .pc-ag-rowhead:hover {\r\n  background: var(--pc-gray-100);\r\n}\r\n.public-comment-root .pc-ag-rowhead:focus-visible {\r\n  outline: 2px solid var(--pc-blue);\r\n  outline-offset: -2px;\r\n}\r\n.public-comment-root .pc-ag-row.pc-open > .pc-ag-rowhead {\r\n  background: var(--pc-blue-pale);\r\n}\r\n.public-comment-root .pc-ag-code {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: var(--pc-blue);\r\n  background: rgba(3, 149, 255, 0.1);\r\n  border-radius: var(--pc-radius-md);\r\n  padding: 5px 0;\r\n  text-align: center;\r\n  min-width: 52px;\r\n}\r\n.public-comment-root .pc-ag-title {\r\n  font-size: 15.5px;\r\n  line-height: 1.45;\r\n  color: var(--pc-ink);\r\n  min-width: 0;\r\n}\r\n\r\n/* comment-count pill */\r\n.public-comment-root .pc-ag-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-weight: 600;\r\n  font-size: 13.5px;\r\n  padding: 6px 12px;\r\n  border-radius: var(--pc-radius-pill);\r\n  white-space: nowrap;\r\n  transition: background var(--pc-fast);\r\n}\r\n.public-comment-root .pc-ag-count svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  fill: currentColor;\r\n  stroke: none;\r\n}\r\n.public-comment-root .pc-ag-count.pc-has {\r\n  background: rgba(3, 149, 255, 0.12);\r\n  color: var(--pc-blue);\r\n}\r\n.public-comment-root .pc-ag-rowhead:hover .pc-ag-count.pc-has {\r\n  background: rgba(3, 149, 255, 0.2);\r\n}\r\n.public-comment-root .pc-ag-count.pc-none {\r\n  background: transparent;\r\n  color: var(--pc-text-subtle);\r\n  font-weight: 400;\r\n}\r\n.public-comment-root .pc-ag-chev {\r\n  width: 20px;\r\n  height: 20px;\r\n  stroke: var(--pc-subtle);\r\n  fill: none;\r\n  stroke-width: 2;\r\n  transition: transform var(--pc-base);\r\n  justify-self: end;\r\n}\r\n.public-comment-root .pc-ag-row.pc-open .pc-ag-chev {\r\n  transform: rotate(180deg);\r\n  stroke: var(--pc-blue);\r\n}\r\n\r\n/* ---------- Expanded panel ---------- */\r\n.public-comment-root .pc-ag-panel {\r\n  padding: 4px 16px 22px;\r\n  background: var(--pc-bg-tinted);\r\n  border-top: 1px solid var(--pc-border-soft);\r\n}\r\n.public-comment-root .pc-panel-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 16px 2px 12px;\r\n  flex-wrap: wrap;\r\n}\r\n.public-comment-root .pc-panel-lbl {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-sortseg {\r\n  display: inline-flex;\r\n  background: #fff;\r\n  border: 1px solid var(--pc-border);\r\n  border-radius: var(--pc-radius-pill);\r\n  padding: 2px;\r\n}\r\n.public-comment-root .pc-sortseg button {\r\n  appearance: none;\r\n  border: 0;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: var(--pc-muted);\r\n  padding: 5px 13px;\r\n  border-radius: var(--pc-radius-pill);\r\n  transition: all var(--pc-fast);\r\n}\r\n.public-comment-root .pc-sortseg button.pc-on {\r\n  background: var(--pc-blue);\r\n  color: #fff;\r\n}\r\n\r\n/* ---------- Comment thread ---------- */\r\n.public-comment-root .pc-thread {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n.public-comment-root .pc-cmt {\r\n  padding: 14px 2px;\r\n  border-top: 1px solid var(--pc-border-soft);\r\n  display: grid;\r\n  grid-template-columns: 38px 1fr;\r\n  gap: 13px;\r\n}\r\n.public-comment-root .pc-thread > .pc-cmt:first-child {\r\n  border-top: 0;\r\n}\r\n.public-comment-root .pc-avatar {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  font-size: 13.5px;\r\n  color: #fff;\r\n  flex: 0 0 38px;\r\n}\r\n.public-comment-root .pc-avatar-sm {\r\n  width: 30px;\r\n  height: 30px;\r\n  flex: 0 0 30px;\r\n  font-size: 11px;\r\n}\r\n.public-comment-root .pc-avatar-anon {\r\n  background: var(--pc-gray-300);\r\n  color: #fff;\r\n}\r\n.public-comment-root .pc-avatar-anon svg {\r\n  width: 19px;\r\n  height: 19px;\r\n  fill: #fff;\r\n  stroke: none;\r\n}\r\n.public-comment-root .pc-avatar-sm.pc-avatar-anon svg {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n.public-comment-root .pc-cmt-main {\r\n  min-width: 0;\r\n}\r\n.public-comment-root .pc-cmt-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 9px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 5px;\r\n}\r\n.public-comment-root .pc-cmt-name {\r\n  font-weight: 600;\r\n  font-size: 14.5px;\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-cmt-time {\r\n  font-size: 12.5px;\r\n  color: var(--pc-text-subtle);\r\n}\r\n.public-comment-root .pc-pos-chip {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  padding: 2px 9px;\r\n  border-radius: var(--pc-radius-pill);\r\n}\r\n.public-comment-root .pc-pos-favor {\r\n  background: rgba(7, 175, 170, 0.12);\r\n  color: var(--pc-teal-deep);\r\n}\r\n.public-comment-root .pc-pos-oppose {\r\n  background: var(--pc-orange-pale);\r\n  color: #c25a08;\r\n}\r\n.public-comment-root .pc-cmt-body {\r\n  font-size: 14.5px;\r\n  line-height: 1.6;\r\n  color: var(--pc-ink);\r\n  margin: 0;\r\n  white-space: pre-wrap;\r\n  overflow-wrap: anywhere;\r\n}\r\n.public-comment-root .pc-cmt-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  margin-top: 9px;\r\n}\r\n.public-comment-root .pc-cact {\r\n  appearance: none;\r\n  border: 0;\r\n  background: none;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-muted);\r\n  padding: 5px 10px;\r\n  border-radius: var(--pc-radius-md);\r\n  transition: all var(--pc-fast);\r\n}\r\n.public-comment-root .pc-cact svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2;\r\n}\r\n.public-comment-root .pc-cact:hover:not(:disabled) {\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-cact:disabled {\r\n  cursor: default;\r\n}\r\n.public-comment-root .pc-cact-vote.pc-on {\r\n  color: var(--pc-blue);\r\n}\r\n.public-comment-root .pc-cact-vote.pc-on svg {\r\n  fill: var(--pc-blue);\r\n  stroke: var(--pc-blue);\r\n}\r\n.public-comment-root .pc-ct {\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n.public-comment-root .pc-sep {\r\n  margin-left: auto;\r\n}\r\n\r\n/* replies */\r\n.public-comment-root .pc-replies {\r\n  margin-top: 12px;\r\n  padding-left: 18px;\r\n  border-left: 2px solid var(--pc-border-soft);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n.public-comment-root .pc-reply {\r\n  display: grid;\r\n  grid-template-columns: 30px 1fr;\r\n  gap: 11px;\r\n}\r\n.public-comment-root .pc-staff-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-weight: 700;\r\n  font-size: 11px;\r\n  color: var(--pc-blue);\r\n  background: var(--pc-blue-pale);\r\n  padding: 2px 9px;\r\n  border-radius: var(--pc-radius-pill);\r\n}\r\n.public-comment-root .pc-staff-badge svg {\r\n  width: 12px;\r\n  height: 12px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.4;\r\n}\r\n\r\n/* pending (author-only) */\r\n.public-comment-root .pc-cmt-pending .pc-cmt-body {\r\n  font-style: italic;\r\n  color: var(--pc-muted);\r\n}\r\n.public-comment-root .pc-pending-note {\r\n  display: flex;\r\n  gap: 9px;\r\n  margin-top: 9px;\r\n  font-size: 12.5px;\r\n  color: var(--pc-muted);\r\n  background: var(--pc-gray-200);\r\n  padding: 8px 12px;\r\n  border-radius: var(--pc-radius-md);\r\n  align-items: flex-start;\r\n}\r\n.public-comment-root .pc-pending-note svg {\r\n  width: 15px;\r\n  height: 15px;\r\n  stroke: var(--pc-muted);\r\n  fill: none;\r\n  stroke-width: 2;\r\n  flex: 0 0 15px;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* inline reply box */\r\n.public-comment-root .pc-replybox {\r\n  margin-top: 12px;\r\n  padding-left: 18px;\r\n}\r\n.public-comment-root .pc-replybox textarea {\r\n  width: 100%;\r\n  min-height: 62px;\r\n  resize: vertical;\r\n  font: inherit;\r\n  font-size: 14px;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--pc-border);\r\n  border-radius: var(--pc-radius-md);\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n}\r\n.public-comment-root .pc-replybox textarea:focus {\r\n  outline: none;\r\n  border-color: var(--pc-blue);\r\n  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);\r\n}\r\n.public-comment-root .pc-rb-foot {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.public-comment-root .pc-empty {\r\n  padding: 18px 2px;\r\n  font-size: 14px;\r\n  color: var(--pc-text-subtle);\r\n  font-style: italic;\r\n}\r\n.public-comment-root .pc-empty-pad {\r\n  padding: 18px 16px;\r\n}\r\n\r\n/* ---------- Compose ---------- */\r\n.public-comment-root .pc-compose {\r\n  margin-top: 16px;\r\n  padding: 16px;\r\n  background: #fff;\r\n  border: 1px solid var(--pc-border-soft);\r\n  border-radius: var(--pc-radius-lg);\r\n}\r\n.public-comment-root .pc-compose-h {\r\n  font-weight: 700;\r\n  font-size: 13.5px;\r\n  color: var(--pc-ink);\r\n  margin: 0 0 10px;\r\n}\r\n.public-comment-root .pc-compose-input {\r\n  width: 100%;\r\n  min-height: 78px;\r\n  resize: vertical;\r\n  font: inherit;\r\n  font-size: 14.5px;\r\n  padding: 11px 13px;\r\n  border: 1px solid var(--pc-border);\r\n  border-radius: var(--pc-radius-md);\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n}\r\n.public-comment-root .pc-compose-input:focus {\r\n  outline: none;\r\n  border-color: var(--pc-blue);\r\n  box-shadow: 0 0 0 3px rgba(3, 149, 255, 0.15);\r\n}\r\n.public-comment-root .pc-compose-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n  margin-top: 11px;\r\n  flex-wrap: wrap;\r\n}\r\n.public-comment-root .pc-compose-as {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 13px;\r\n  color: var(--pc-muted);\r\n}\r\n.public-comment-root .pc-av-mini {\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  font-size: 10px;\r\n  color: #fff;\r\n  background: var(--pc-blue);\r\n}\r\n.public-comment-root .pc-av-mini-anon {\r\n  background: var(--pc-gray-300);\r\n}\r\n.public-comment-root .pc-av-mini-anon svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  fill: #fff;\r\n  stroke: none;\r\n}\r\n.public-comment-root .pc-av-mini-staff {\r\n  background: var(--pc-blue);\r\n}\r\n\r\n/* \"Post on behalf of {agency}\" — shown to meeting admins only */\r\n.public-comment-root .pc-post-as {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-top: 11px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-blue);\r\n  cursor: pointer;\r\n}\r\n.public-comment-root .pc-post-as input {\r\n  width: 15px;\r\n  height: 15px;\r\n  accent-color: var(--pc-blue);\r\n  cursor: pointer;\r\n}\r\n.public-comment-root .pc-post-as svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.4;\r\n}\r\n.public-comment-root .pc-compose-as strong {\r\n  color: var(--pc-ink);\r\n  font-weight: 600;\r\n}\r\n\r\n/* stance picker */\r\n.public-comment-root .pc-stance-pick {\r\n  display: inline-flex;\r\n  gap: 7px;\r\n  margin-right: auto;\r\n}\r\n.public-comment-root .pc-stance-pick label {\r\n  cursor: pointer;\r\n  position: relative;\r\n  font-size: 12.5px;\r\n  font-weight: 600;\r\n  color: var(--pc-muted);\r\n  border: 1px solid var(--pc-border);\r\n  border-radius: var(--pc-radius-pill);\r\n  padding: 5px 13px;\r\n  background: #fff;\r\n  transition: all var(--pc-fast);\r\n}\r\n.public-comment-root .pc-stance-pick label input {\r\n  position: absolute;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n/* The radio is visually hidden, so surface keyboard focus on its label (WCAG 2.4.7). */\r\n.public-comment-root .pc-stance-pick label:focus-within {\r\n  outline: 2px solid var(--pc-blue);\r\n  outline-offset: 1px;\r\n}\r\n.public-comment-root .pc-stance-pick .pc-favor.pc-checked {\r\n  border-color: var(--pc-teal-deep);\r\n  background: rgba(7, 175, 170, 0.1);\r\n  color: var(--pc-teal-deep);\r\n}\r\n.public-comment-root .pc-stance-pick .pc-oppose.pc-checked {\r\n  border-color: var(--pc-orange);\r\n  background: var(--pc-orange-pale);\r\n  color: #c25a08;\r\n}\r\n.public-comment-root .pc-stance-pick .pc-neutral.pc-checked {\r\n  border-color: var(--pc-muted);\r\n  background: var(--pc-gray-200);\r\n  color: var(--pc-ink);\r\n}\r\n\r\n/* ---------- Buttons ---------- */\r\n.public-comment-root .pc-btn {\r\n  appearance: none;\r\n  border: 0;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 10px 20px;\r\n  border-radius: var(--pc-radius-lg);\r\n  transition: background var(--pc-base), transform var(--pc-fast);\r\n}\r\n.public-comment-root .pc-btn-primary {\r\n  background: var(--pc-blue);\r\n  color: #fff;\r\n}\r\n.public-comment-root .pc-btn-primary:hover:not(:disabled) {\r\n  background: var(--pc-blue-deep);\r\n}\r\n.public-comment-root .pc-btn-primary:active {\r\n  transform: translateY(1px);\r\n}\r\n.public-comment-root .pc-btn:disabled {\r\n  opacity: 0.8;\r\n  cursor: not-allowed;\r\n}\r\n.public-comment-root .pc-btn-ghost {\r\n  background: transparent;\r\n  color: var(--pc-muted);\r\n  font-size: 13px;\r\n  padding: 8px 14px;\r\n}\r\n.public-comment-root .pc-btn-ghost:hover {\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-btn-sm {\r\n  font-size: 13px;\r\n  padding: 8px 16px;\r\n}\r\n/* Inline processing spinner shown in Submit / Reply buttons while a post is in flight. */\r\n.public-comment-root .pc-spin {\r\n  display: inline-block;\r\n  width: 13px;\r\n  height: 13px;\r\n  margin-right: 7px;\r\n  vertical-align: -2px;\r\n  border: 2px solid currentColor;\r\n  border-right-color: transparent;\r\n  border-radius: 50%;\r\n  animation: pc-spin 0.6s linear infinite;\r\n}\r\n@keyframes pc-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .public-comment-root .pc-spin {\r\n    animation-duration: 1.4s;\r\n  }\r\n}\r\n\r\n/* ---------- Moderation notice ---------- */\r\n.public-comment-root .pc-mod-notice {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-top: 12px;\r\n  padding: 13px 15px;\r\n  background: var(--pc-orange-pale);\r\n  border: 1px solid var(--pc-orange-soft);\r\n  border-radius: var(--pc-radius-lg);\r\n  animation: pc-fade 200ms ease-out;\r\n}\r\n.public-comment-root .pc-mod-notice svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  stroke: #c25a08;\r\n  fill: none;\r\n  stroke-width: 2;\r\n  flex: 0 0 20px;\r\n  margin-top: 1px;\r\n}\r\n.public-comment-root .pc-mn-t {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  color: #a04a06;\r\n  margin: 0 0 3px;\r\n}\r\n.public-comment-root .pc-mn-d {\r\n  font-size: 13.5px;\r\n  line-height: 1.55;\r\n  color: #8a4408;\r\n  margin: 0;\r\n}\r\n@keyframes pc-fade {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-4px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: none;\r\n  }\r\n}\r\n\r\n/* ---------- Responsive ---------- */\r\n@media (max-width: 720px) {\r\n  .public-comment-root .pc-field-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .public-comment-root .pc-ag-colhead {\r\n    grid-template-columns: 60px 1fr auto;\r\n  }\r\n  /* Keep the chevron disclosure affordance on touch/kiosk widths (its own column). */\r\n  .public-comment-root .pc-ag-rowhead {\r\n    grid-template-columns: 60px 1fr auto auto;\r\n  }\r\n  .public-comment-root .pc-search {\r\n    flex-basis: 100%;\r\n    max-width: none;\r\n  }\r\n  .public-comment-root .pc-compose-foot {\r\n    align-items: stretch;\r\n  }\r\n}\r\n\r\n/* ---------- Attachments (composer) ---------- */\r\n.public-comment-root .pc-attach {\r\n  margin-top: 11px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n.public-comment-root .pc-attach-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  width: 100%;\r\n}\r\n.public-comment-root .pc-attach-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  max-width: 100%;\r\n  padding: 5px 8px;\r\n  background: var(--pc-gray-100);\r\n  border: 1px solid var(--pc-border-soft);\r\n  border-radius: var(--pc-radius-md);\r\n  font-size: 12.5px;\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-attach-name {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  max-width: 200px;\r\n}\r\n.public-comment-root .pc-attach-size {\r\n  color: var(--pc-text-subtle);\r\n  font-size: 11.5px;\r\n}\r\n.public-comment-root .pc-attach-ic {\r\n  width: 14px;\r\n  height: 14px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2;\r\n  flex-shrink: 0;\r\n}\r\n.public-comment-root .pc-attach-rm {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 0;\r\n  margin-left: 2px;\r\n  cursor: pointer;\r\n  color: var(--pc-muted);\r\n}\r\n.public-comment-root .pc-attach-rm svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.2;\r\n}\r\n.public-comment-root .pc-attach-rm:hover {\r\n  color: var(--pc-ink);\r\n}\r\n.public-comment-root .pc-attach-add {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 11px;\r\n  border: 1px dashed var(--pc-border);\r\n  border-radius: var(--pc-radius-md);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-blue);\r\n  cursor: pointer;\r\n  transition: background var(--pc-fast), border-color var(--pc-fast);\r\n}\r\n.public-comment-root .pc-attach-add:hover {\r\n  background: var(--pc-blue-pale);\r\n  border-color: var(--pc-blue);\r\n}\r\n.public-comment-root .pc-attach-input {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  clip: rect(0 0 0 0);\r\n}\r\n.public-comment-root .pc-attach-hint {\r\n  font-size: 11.5px;\r\n  color: var(--pc-text-subtle);\r\n}\r\n.public-comment-root .pc-attach-err {\r\n  width: 100%;\r\n  margin: 2px 0 0;\r\n  font-size: 12.5px;\r\n  color: #c0392b;\r\n}\r\n\r\n/* ---------- Private (hidden) comment toggle ---------- */\r\n.public-comment-root .pc-private {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-top: 11px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-text-subtle);\r\n  cursor: pointer;\r\n}\r\n.public-comment-root .pc-private input {\r\n  width: 15px;\r\n  height: 15px;\r\n  accent-color: var(--pc-blue);\r\n  cursor: pointer;\r\n}\r\n.public-comment-root .pc-private svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.2;\r\n}\r\n.public-comment-root .pc-av-mini-private {\r\n  background: var(--pc-text-subtle);\r\n}\r\n.public-comment-root .pc-av-mini-private svg {\r\n  width: 12px;\r\n  height: 12px;\r\n  stroke: #fff;\r\n  fill: none;\r\n  stroke-width: 2.2;\r\n}\r\n.public-comment-root .pc-private-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 1px 7px;\r\n  border-radius: var(--pc-radius-pill);\r\n  background: var(--pc-gray-200);\r\n  color: var(--pc-text-subtle);\r\n  font-size: 11.5px;\r\n  font-weight: 600;\r\n}\r\n.public-comment-root .pc-private-badge svg {\r\n  width: 11px;\r\n  height: 11px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2.2;\r\n}\r\n\r\n/* ---------- Reply admin toggle ---------- */\r\n.public-comment-root .pc-post-as-reply {\r\n  margin-top: 8px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n/* ---------- Comment attachments (feed) ---------- */\r\n.public-comment-root .pc-cmt-atts {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin: 8px 0 2px;\r\n}\r\n.public-comment-root .pc-att-img {\r\n  display: block;\r\n  border-radius: var(--pc-radius-md);\r\n  overflow: hidden;\r\n  border: 1px solid var(--pc-border-soft);\r\n  max-width: 180px;\r\n}\r\n.public-comment-root .pc-att-img img {\r\n  display: block;\r\n  max-width: 180px;\r\n  max-height: 160px;\r\n  object-fit: cover;\r\n}\r\n.public-comment-root .pc-att-doc {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 7px 11px;\r\n  background: var(--pc-gray-100);\r\n  border: 1px solid var(--pc-border-soft);\r\n  border-radius: var(--pc-radius-md);\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--pc-blue);\r\n  text-decoration: none;\r\n}\r\n.public-comment-root .pc-att-doc:hover {\r\n  background: var(--pc-blue-pale);\r\n}\r\n.public-comment-root .pc-att-doc-ic {\r\n  width: 15px;\r\n  height: 15px;\r\n  stroke: currentColor;\r\n  fill: none;\r\n  stroke-width: 2;\r\n}\r\n.public-comment-root .pc-att-doc-name {\r\n  max-width: 220px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
